import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import Typography from 'fuse-ui/components/Typography';
import Radio from 'fuse-ui/components/Radio';

import { senderStatusDisplayMap } from '../common/constants/sender-status';
import {
    SENDER_STATUS_ACCEPTED,
    SENDER_STATUS_REJECTED,
    SENDER_STATUS_UNDECIDED
} from '../common/constants/definitions';

const styles = theme => ( {
    checkboxColumn: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    dividerMiddle: {
        margin: `0 ${theme.spacing.unit * 3}px`,
    },
    listItemEditRoot: {
        display: 'grid',
        gridTemplateColumns: '55% 15% 15% 15%',
        gridTemplateRows: 'minmax(36px, max-content)',
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    listItemRoot: {
        display: 'grid',
        gridTemplateColumns: '70% 30%',
        gridTemplateRows: 'minmax(36px, max-content)',
        padding: 0,
    },
} );

const SenderStatusListItem = ( { classes, editMode, item, onSelection } ) => {
    function onChange( event ){
        return onSelection( item.id )( event );
    }

    return (
        <ListItem
            data-automation-id="sender-status-list-sender"
            classes={{ root: editMode ? classes.listItemEditRoot : classes.listItemRoot }}
            divider={true}
        >
            <Typography data-automation-id="sender-status-list-sender-name">{item.name}</Typography>
            {
                !editMode &&
                <Typography data-automation-id="dd-sender-status-list-definitions">{senderStatusDisplayMap[item.status]}</Typography>
            }
            {
                editMode &&
                ( <>
                    <div className={classes.checkboxColumn}>
                        <Radio
                            checked={item.status === SENDER_STATUS_ACCEPTED}
                            onChange={onChange}
                            value={SENDER_STATUS_ACCEPTED}
                            data-automation-id="sender-status-list-verified-checkbox"
                        />
                    </div>
                    <div className={classes.checkboxColumn}>
                        <Radio checked={item.status === SENDER_STATUS_UNDECIDED}
                            onChange={onChange}
                            value={SENDER_STATUS_UNDECIDED}
                            data-automation-id="sender-status-list-uncertain-checkbox"
                        />
                    </div>
                    <div className={classes.checkboxColumn}>
                        <Radio checked={item.status === SENDER_STATUS_REJECTED}
                            onChange={onChange}
                            value={SENDER_STATUS_REJECTED}
                            data-automation-id="sender-status-list-rejected-checkbox"
                        />
                    </div>
                </> )
            }
        </ListItem>
    );
};

SenderStatusListItem.propTypes = {
    classes: PropTypes.object.isRequired,
    editMode: PropTypes.bool.isRequired,
    item: PropTypes.shape( {
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
    } ).isRequired,
    onSelection: PropTypes.func,
};

export default withStyles( styles )( SenderStatusListItem );
